import React from 'react';
import PropTypes from 'prop-types';

import { Common } from 'ws-scripts/modules/common';

const Logo = ({ href, target, className, alt, src, params }) => (
	<Common
		render={({ labels, sitemap }) => {
			return (
				<a
					href={
						sitemap.has(href)
							? sitemap.get(href) + (params || '')
							: href + (params || '')
					}
					target={target}
				>
					<img
						className={className}
						src={src}
						alt={labels.get(alt)}
					/>
				</a>
			);
		}}
	/>
);

Logo.propTypes = {
	href: PropTypes.string.isRequired,
	target: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	src: PropTypes.string.isRequired,
	params: PropTypes.string.isRequired
};

export default Logo;
